// extracted by mini-css-extract-plugin
export default {"root":"ButtonPadding-root-f43cc5a0b0a69775434c6743bbe7bf5d"};